import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router';

import Strings from '../../Strings';
import { actionsAdvancedFilters } from './actions';
import BarItem from './internals/BarItem';
import { getRelevantFilters, getFiltersForRequest } from './helpers';

export const MAX_VISIBLE_FILTERS = 10;

export const getVisibleFilters = (filters, maxVisibleFilters = MAX_VISIBLE_FILTERS) => {
  const relevantFilters = getRelevantFilters(filters);
  const visibleFilters = relevantFilters.slice(0, maxVisibleFilters);

  return {
    visibleFilters,
    hiddenFiltersCount: relevantFilters.length - visibleFilters.length,
  };
};

class AdvancedFiltersBar extends React.PureComponent {
  componentWillUnmount() {
    const { clearAll } = this.props;
    clearAll();
  }

  clearFilters = () => {
    const { clearAll, replacePath } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('filters', JSON.stringify([]));
    replacePath(`${window.location.pathname}?${urlParams}`);
    clearAll();
  };

  getStatusRepresentants = () => {
    const { filters, updateFilterState, customFilters, maxVisibleFilters } = this.props;
    const { visibleFilters, hiddenFiltersCount } = getVisibleFilters(filters, maxVisibleFilters);

    const representants = visibleFilters.map((filter, i) => (
      <BarItem updateFilterState={updateFilterState} key={i} filter={filter} customFilters={customFilters} />
    ));

    if (hiddenFiltersCount > 0) {
      representants.push(
        <div className="bar-item bar-item-summary" key="hidden-filters-summary">
          <div className="item-label">
            <div>{Strings.formatString(Strings.andXmore, hiddenFiltersCount)}</div>
          </div>
        </div>,
      );
    }

    return representants;
  };

  componentDidUpdate(prevProps) {
    const { filters, isFiltersInitialized, replacePath } = this.props;

    if (filters !== prevProps.filters && isFiltersInitialized) {
      // lets replace current entry in history with new one with filters state
      const filtersSerialized = JSON.stringify(getFiltersForRequest(filters));
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('filters', filtersSerialized);
      replacePath(`${window.location.pathname}?${urlParams}`);
    }
  }

  render() {
    const clearButton = (
      <div className="round-button" onClick={this.clearFilters}>
        {Strings.clear}
      </div>
    );

    const reps = this.getStatusRepresentants();

    if (reps.length !== 0) {
      return (
        <div className="advanced-filters">
          <div className="horizontal-line" />
          <div className="advanced-filters-bar">
            {clearButton}
            {reps}
          </div>
        </div>
      );
    }
    return null;
  }
}

AdvancedFiltersBar.propTypes = {
  clearFilters: PropTypes.func.isRequired,
  clearAll: PropTypes.func.isRequired,
  filters: PropTypes.array.isRequired,
  updateFilterState: PropTypes.func.isRequired,
  replacePath: PropTypes.func.isRequired,
  isFiltersInitialized: PropTypes.bool.isRequired,
  customFilters: PropTypes.object,
  maxVisibleFilters: PropTypes.number,
};

AdvancedFiltersBar.defaultProps = {
  customFilters: undefined,
  maxVisibleFilters: MAX_VISIBLE_FILTERS,
};

const mapStateToProps = state => {
  return {
    filters: state.entities.advancedFilters.filters.items,
    isFiltersInitialized: state.entities.advancedFilters.filters.isInitalized,
  };
};

const mapDispatchToProps = dispatch => ({
  clearFilters: () => dispatch(actionsAdvancedFilters.clearFilters()),
  clearAll: () => dispatch(actionsAdvancedFilters.clearAll()),
  updateFilterState: (state, filterType) => dispatch(actionsAdvancedFilters.updateFilterState(state, filterType)),
  replacePath: path => dispatch(replace(path)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedFiltersBar);
